import { LootDeathBehavior } from '@phaser/behaviors/LootDeath.behavior';
import { CardObject } from '@phaser/objects/Card.object';
import * as Shared from '@shared/lib';

export class LootObject extends CardObject {
  constructor(data: Shared.CardSpawnMessage) {
    super(data);

    new LootDeathBehavior(this);
  }

  public override destroy() {
    this._effectBehavior.destroy();
    this.container.destroy();
  }
}